<template>
  <div class="client-notifications">

    <div class="notification-container" :style="{ display: containerVisible ? 'block' : 'none' }">
      <div class="notification-header">
        <img src="/img/svg/common/bell-v2.svg"
             width="30px"
             height="35px"
             alt="">
        <span>{{ getLocalization('Notifications') }}</span>
      </div>
      <SimpleBar class="notifications-list" v-if="notifications" ref="notificationsList">
        <div v-for="(notification, index) in notifications" :key="index" class="notification-item">

          <button class="close-button" @click="hideNotification(notification, index)">
            <span class="close-icon"></span>
          </button>

          <div class="notification-content" :class="{ 'expanded': expandedStates[index] }">
            <div class="notification-details">
              <div v-if="!notification.common_img" class="notification-row" ref="detailsElements">
                <div class="notification-detail-row">
                  <img v-if="notification.title_img" :src="notification.title_img"
                       width="18px"
                       height="18px"
                       alt="">
                  <p class="title" v-if="notification.title" v-html="formate(notification.title)"></p>
                </div>
                <div class="notification-detail-row">
                  <img v-if="notification.message_img" :src="notification.message_img"
                       width="18px"
                       height="18px"
                       alt="">
                  <p class="message" v-if="notification.message">{{ formate(notification.message) }}</p>
                </div>
              </div>

              <div v-else class="notification-row common-img" ref="detailsElements">
                <img v-if="notification.common_img" :src="notification.common_img"
                     width="25px"
                     height="25px"
                     alt="">
                <div>
                  <div class="notification-detail-row">
                    <p class="title" v-if="notification.title" v-html="formate(notification.title)"></p>
                  </div>
                  <div class="notification-detail-row">
                    <p class="message" v-if="notification.message">{{ formate(notification.message) }}</p>
                  </div>
                </div>
              </div>


              <div class="fade-overlay" v-if="needsExpand[index] && !expandedStates[index]"></div>
            </div>
          </div>
          <button class="expand-button"
                  v-if="needsExpand[index]"
                  @click="toggleExpand(index)"
                  :aria-expanded="expandedStates[index]">
            {{ expandedStates[index] ? getLocalization('Hide') : getLocalization('Show') }}
            <svg class="icon" width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M19 9l-7 7-7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </SimpleBar>

    </div>
  </div>
</template>

<script>
import BaseAdminMixin from "../../../../admin/components/mixins/BaseAdminMixin.vue";

const MAX_HEIGHT = 74; // максимальная высота окна сообщения, без кнопки развернуть

import MainModal from "./modals/mainModal.vue"
import SimpleBar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

export default {
  name: "NotificationsComponent",
  components: {MainModal, SimpleBar},
  mixins: [
    BaseAdminMixin
  ],
  data() {
    return {
      expandedStates: {},
      needsExpand: {},
      containerVisible: false,
      observer: null,
      modals: null,
      isFullHeight: false,
      notifications: null,
    };
  },
  mounted() {
    this.addEventListener();
    this.initMutationObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }

    const notification = document.querySelector('.notification-container');
    if (notification) {
      notification.removeEventListener('displayChanged');
    }
  },
  methods: {
    addEventListener() {
      const notification = document.querySelector('.notification-container');
      if (notification) {
        notification.addEventListener('displayChanged', (e) => {
          if (e.detail === 'block') {
            // Добавляем небольшую задержку перед загрузкой
            setTimeout(() => {
              this.initMutationObserver();
            }, 50);
          }
        }, {passive: true});
      }
    },
    async getNotifications() {
      const response = await this.sendRequest('cabinet/client/notification/getNotifications', 'get', {'lang': document.documentElement.lang});
      this.notifications = response.notifications;


      await this.$nextTick();
      this.checkElementsHeight();
    },
    async hideNotification(notification, index) {
      await this.sendRequest('cabinet/client/notification/delete', 'post', {notificationId: notification.id});
      delete this.notifications[index]
      this.notifications = {...this.notifications};
    },
    initMutationObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }

      const container = this.$el.querySelector('.notification-container');
      if (!container) return;

      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const displayValue = container.style.display;
            const wasVisible = this.containerVisible;
            this.containerVisible = displayValue !== 'none';

            if (wasVisible !== this.containerVisible) {
              if (this.containerVisible) {
                setTimeout(() => {
                  this.getNotifications();
                }, 50);
              }
            }
          }
        });
      });

      this.observer.observe(container, {
        attributes: true,
        attributeFilter: ['style']
      });
    },
    formate(text) {
      if (text === null) {
        return '';
      }
      return text.replace(/###/g, '<br>')
    },
    checkElementsHeight() {
      if (!this.$refs.detailsElements) return;

      this.$refs.detailsElements.forEach((el, index) => {
        const needsExpand = el.clientHeight > MAX_HEIGHT;
        this.$set(this.needsExpand, index, needsExpand);
        if (!this.expandedStates.hasOwnProperty(index)) {
          this.$set(this.expandedStates, index, false);
        }
      });
    },
    toggleExpand(index) {
      this.$set(this.expandedStates, index, !this.expandedStates[index]);
    }
  }
};
</script>

<style scoped lang="scss">
.client-notifications {
  display: flex;
  justify-content: end;
}

.notification-container {
  z-index: 10;
  margin: -90px 269px 0 0;
  background-color: #C8E8D8;
  border: 1px solid #2F7C5D54;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: absolute;
  width: 100%;
  max-width: 445px;
  padding-bottom: 26px;
}

@media only screen and (max-width: 1200px) {
  .notification-container {
    margin: 0;
  }
}

.notification-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  img {
    margin-right: 8px;
  }

  span {
    color: black;
    font-family: 'Heading-Medium';
    font-weight: 400;
    letter-spacing: 0.005em;
    font-size: 24px;
    text-align: center;
  }
}

:deep() {
  .simplebar-scrollbar::before {
    background-color: #79C5A1;
    opacity: 1;
    border-radius: 16px;
  }

  .simplebar-track {
    background-color: #ACDFC6;
    border-radius: 16px;
    width: 5px;
  }
}

.notifications-list {
  padding: 0 10px 0 0;
  max-height: 360px;
}

.notification-item {
  background-color: #E0F5EB;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  position: relative;
}

.notification-content {
  max-height: 74px;
  display: flex;
  width: 100%;
  position: relative;
  overflow: hidden;

  &.expanded {
    max-height: none;
    overflow: visible;
  }
}

.notification-details {
  flex: 1;
  position: relative;
}

.notification-details .title {
  font-weight: 450;
  font-size: 14px;
  color: #666;
  line-height: 1.1;
  margin-bottom: 8px;
}

.notification-details .message {
  font-size: 14px;
  color: #666;
  line-height: 1.1;
}

.fade-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #E0F5EB);
  pointer-events: none;
}

.expand-button {
  position: absolute;
  bottom: 0;
  right: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 500;
  color: #0a3622;
  cursor: pointer;
  z-index: 2;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  .icon {
    transition: transform 0.2s ease;
  }

  &[aria-expanded="true"] {
    .icon {
      transform: rotate(180deg);
    }
  }
}

.common-img {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notification-detail-row {
  display: flex;

  img {
    margin-right: 4px;
  }
}

.close-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  transition: transform 0.2s ease;
}

.close-button:hover {
  transform: rotate(90deg);
}

.close-icon {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

.close-icon::before,
.close-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 13px;
  height: 2px;
  background-color: #5E7A71;
  border-radius: 1px;
  transform-origin: center;
}

.close-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close-icon::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.close-button:hover .close-icon::before,
.close-button:hover .close-icon::after {
  background-color: #2F7C5D;
}
</style>